import { styled } from 'styled-components';

import { cssBreakpoints, sectionPadding } from '#/theme/theme';

export const CmsPageBody_Box_1 = styled.div`
  margin: ${sectionPadding[0]};

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin: ${sectionPadding[2]};
  }
`;

export const CmsPageBody_Box_2 = styled.div`
  margin: ${sectionPadding[0]};

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin: ${sectionPadding[2]};
  }
`;
